import React from 'react';
import { ClipboardListIcon, ClockIcon, MailIcon, MapPinIcon, MessageCircleIcon, PhoneIcon } from 'lucide-react';
import { contact } from '../data/site';
import { SectionHeading } from './SectionHeading';
const details = [{
  icon: PhoneIcon,
  label: 'Phone',
  value: contact.phone,
  href: contact.phoneHref
}, {
  icon: MailIcon,
  label: 'Email',
  value: contact.email,
  href: `mailto:${contact.email}`
}, {
  icon: ClockIcon,
  label: 'Hours',
  value: contact.hoursLong
}, {
  icon: MapPinIcon,
  label: 'Location',
  value: contact.location
}];
export function Contact() {
  return <section id="contact" className="w-full bg-white" data-id="element-15" data-mp="3k4mh7khn3kpy">
      <div className="mx-auto max-w-7xl px-6 py-20 lg:py-24" data-id="element-16" data-mp="3k330jss2n7nn">
        <SectionHeading eyebrow="Get in Touch" title="Contact Us" description="Give us a call or drop us a message for a free, no-obligation quote. We're here to help with all your cleaning and property support needs." data-id="element-17" data-mp="3f5jo8yexp4yc" />

        <div className="mt-14 grid gap-12 lg:grid-cols-[1.1fr_1fr] lg:items-start" data-id="element-18" data-mp="3jvuoi21wstoz">
          <ul className="grid gap-8 sm:grid-cols-2" data-id="element-19" data-mp="3ouo543cht0td">
            {details.map(detail => <li key={detail.label} className="flex gap-4" data-id="element-20" data-mp="3b39at0d4xd70">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center bg-navy" data-id="element-21" data-mp="3b2rhoclrrf3b">
                  <detail.icon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-22" data-mp="3f3beff2fkgox" />
                </span>
                <div data-id="element-23" data-mp="313ih30wef27z">
                  <h3 className="font-display text-[13px] font-extrabold uppercase tracking-wider text-navy" data-id="element-24" data-mp="31767hr6jr8ih">
                    {detail.label}
                  </h3>
                  {detail.href ? <a href={detail.href} className="mt-1 block text-[15px] text-gray-600 transition-colors hover:text-gold" data-id="element-25" data-mp="2s6ro4xd583hm">
                      {detail.value}
                    </a> : <p className="mt-1 text-[15px] text-gray-600" data-id="element-26" data-mp="ududmx9l6690">{detail.value}</p>}
                </div>
              </li>)}
          </ul>

          <div className="bg-navy p-8 lg:p-10" data-id="element-27" data-mp="1ybfwgvxygafq">
            <p className="font-display text-[12px] font-bold uppercase tracking-[0.28em] text-gold" data-id="element-28" data-mp="1yeu007icupor">
              Free Quote
            </p>
            <h3 className="mt-3 font-display text-2xl font-extrabold uppercase tracking-wide text-white" data-id="element-29" data-mp="1pcktrtu4dih6">
              Talk to us today
            </h3>
            <p className="mt-3 text-[15px] leading-relaxed text-white/70" data-id="element-30" data-mp="2m3wh9e92ugiq">
              Tell us about the property and your deadline — we'll come back with a
              clear price and no obligation.
            </p>

            <div className="mt-8 flex flex-col gap-3" data-id="element-31" data-mp="28ax0l8xk6g9l">
              <a href={contact.phoneHref} className="flex items-center justify-center gap-3 bg-gold px-7 py-4 font-display text-[13px] font-bold uppercase tracking-widest text-white transition-colors hover:bg-gold-dark" data-id="element-32" data-mp="28aewjq4nmxr4">
                <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-33" data-mp="38bipcc822c5z" />
                Call {contact.phone}
              </a>
              <a href={`mailto:${contact.email}`} className="flex items-center justify-center gap-3 border border-white/40 px-7 py-4 font-display text-[13px] font-bold uppercase tracking-widest text-white transition-colors hover:bg-white hover:text-navy" data-id="element-34" data-mp="3da3os9fhgrtd">
                <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-35" data-mp="3r8tkplqkglg5" />
                Email Us
              </a>
              <a href="https://wa.me/447781113434" target="_blank" rel="noreferrer" className="flex items-center justify-center gap-3 border border-white/40 px-7 py-4 font-display text-[13px] font-bold uppercase tracking-widest text-white transition-colors hover:bg-white hover:text-navy" data-id="element-36" data-mp="17afa9cdkqb">
                <MessageCircleIcon className="h-4 w-4" aria-hidden="true" data-id="element-37" data-mp="iub9xc98qrsu" />
                Message on WhatsApp
              </a>
              <a href="https://tally.so/r/lboqeW" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-3 border border-white/40 px-7 py-4 text-center font-display text-[13px] font-bold uppercase tracking-widest text-white transition-colors hover:bg-white hover:text-navy" data-id="element-38" data-mp="54q1k0aldtdb">
                <ClipboardListIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-39" data-mp="3idmf4x8wswfb" />
                Complete Our Enquiry Form
              </a>
              <p className="text-[14px] leading-relaxed text-white/70" data-id="element-40" data-mp="3sb8ypx15lc5m">
                Prefer to send us your requirements online? Complete our quick enquiry
                form and tell us about your cleaning needs.
              </p>
            </div>

            <p className="mt-6 text-[13px] text-white/50" data-id="element-41" data-mp="17jgjc61o8ety">
              {contact.hours} · Fully insured · Guernsey-wide
            </p>
          </div>
        </div>
      </div>
    </section>;
}